<template>
  <div>
    <div class="home_page">
      <Breadcrumb :pageTitle="pageTitle" />
    </div>
    <div class="all lianchulianbei home_page">
      <div
        style="
          width: 100%;
          height: 40px;
          width: 100%;
          padding-top: 5px;
          padding-bottom: 5px;
        "
      >
        <div
          :class="{ zhuangtaiclick: number === 'all' }"
          class="zhuangtai"
          @click="changeStatus('all')"
        >
          {{ $t("stockNeed.tabs1") }}
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '10' }"
          @click="changeStatus('10')"
        >
          {{ $t("stockNeed.tabs2") }}({{ orderStatusArr.type1 }})
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '20,30,40,50' }"
          @click="changeStatus('20,30,40,50')"
        >
          {{ $t("stockNeed.tabs5") }}({{ orderStatusArr.type2 }})
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '60,70' }"
          @click="changeStatus('60,70')"
        >
          {{ $t("stockNeed.tabs6") }}({{ orderStatusArr.type3 }})
        </div>
        <div
          class="zhuangtai"
          :class="{ zhuangtaiclick: number === '80' }"
          @click="changeStatus('80')"
        >
          {{ $t("stockNeed.tabs4") }}({{ orderStatusArr.type4 }})
        </div>
        <div style="float: right; margin-right: 10px">
          <el-button
            type="primary"
            :loading="downloadLoading"
            @click="download"
            class="download primary"
            icon="el-icon-download"
            >{{ $t("orderlist.export") }}</el-button
          >
          <el-button
            @click="handleSaveReceive"
            class="primary"
            type="primary"
            icon="el-icon-plus"
            >{{ $t("add") }}</el-button
          >
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList(1)"
          @submit.native.prevent
        >
          <div class="search-row">
            <div class="search-conent" style="min-width: 300px">
              <el-form-item label="">
                <el-select
                  v-model="dataForm.timeTag"
                  clearable
                  @change="changeTimeTag"
                  style="width: 300px"
                  :placeholder="$t('common.date')"
                >
                  <el-option
                    v-for="item in dateOptions"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="search-conent" style="min-width: 300px">
              <el-form-item label="">
                <el-input
                  v-model="dataForm.searchInput"
                  style="width: 300px"
                  :placeholder="$t('stockNeed.placeholder')"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="search-but" style="width: 110px">
              <el-button
                @click="getDataList(1)"
                style="width: 90px"
                type="primary"
                >{{ $t("common.query") }}</el-button
              >
            </div>
            <div
              class="search-but"
              v-if="!showsearchall"
              style="width: 300px; line-height: 40px; color: #0064c0"
            >
              <span style="cursor: pointer" @click="showAll">{{
                $t("common.advancedQuery")
              }}</span>
              <i
                style="cursor: pointer; margin-left: 5px"
                @click="showAll"
                class="el-icon-arrow-down"
              ></i>
            </div>
          </div>
          <div class="search-row" v-if="showsearchall">
            <div class="search-conent">
              <el-form-item>
                <el-input
                  v-model="dataForm.custGoodsCode"
                  :placeholder="$t('product.codes')"
                  style="width: 300px"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item>
                <el-input
                  v-model="dataForm.model"
                  :placeholder="$t('common.model')"
                  style="width: 300px"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="search-conent">
              <el-form-item>
                <el-input
                  v-model="dataForm.goodsName"
                  :placeholder="$t('ordervote.productName')"
                  style="width: 300px"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="search-row" v-if="showsearchall">
            <div class="search-conent">
              <el-form-item>
                <el-date-picker
                  v-model="dataForm.dateValue"
                  type="daterange"
                  align="left"
                  @change="changedateValue"
                  :start-placeholder="$t('stockNeed.startDate')"
                  :end-placeholder="$t('stockNeed.endDate')"
                  value-format="yyyy-MM-dd"
                  :disabled="
                    dataForm.timeTag === '0' ||
                    dataForm.timeTag === '1' ||
                    dataForm.timeTag === '2' ||
                    dataForm.timeTag === '3'
                  "
                  style="width: 300px"
                ></el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div
            v-if="showsearchall"
            style="
              width: 100%;
              line-height: 40px;
              color: #0064c0;
              height: 40px;
              text-align: center;
              margin-top: 5px;
            "
          >
            <span style="cursor: pointer" @click="hideAll">{{
              $t("common.collapse")
            }}</span>
            <i
              style="cursor: pointer; margin-left: 5px"
              @click="hideAll"
              class="el-icon-arrow-up"
            ></i>
          </div>
        </el-form>
      </div>
      <div class="tabletitle">
        <div style="width: 55%">{{ $t("stockNeed.applyDetail") }}</div>
        <div style="width: 15%">{{ $t("stockNeed.total") }}</div>
        <div style="width: 15%">{{ $t("product.status") }}</div>
        <div style="width: 15%">{{ $t("handle") }}</div>
      </div>
      <div
        v-loading="dataLoading"
      >
      <div
        v-for="item in dataList"
        style="box-sizing: border-box"
        :key="item.orderId"
      >
        <div
          style="
            box-sizing: border-box;
            width: 100%;
            height: 50px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            line-height: 49px;
            padding-left: 20px;
          "
        >
          <span style="box-sizing: border-box; float: left"
            ><span style="color: #999999">{{ item.createTime }}</span></span
          >
          <span style="box-sizing: border-box; float: left; margin-left: 30px">
            <span style="color: #999999">{{ $t("stockNeed.orderNo") }}：</span>
            <span style="color: #333333">{{ item.orderCode }}</span>
            <Copyable v-if="item.orderCode" :text="item.orderCode" />
          </span>

          <span style="margin-left: 30px">
            <span style="color: #999999">客户单号：</span>
            <span style="color: #333333">{{ item.custOrderNo || "-" }}</span>
            <Copyable v-if="item.custOrderNo" :text="item.custOrderNo" />
          </span>
        </div>
        <div
          style="
            box-sizing: border-box;
            width: 100%;
            background: #ffffff;
            border: 1px solid #eeeeee;
            padding-left: 20px;
            border-top: none;
          "
          :class="{
            activeOne: item.itemVos.length === 1,
            activeTwo: item.itemVos.length === 2,
            activeThree: item.itemVos.length === 3,
          }"
        >
          <div
            style="
              box-sizing: border-box;
              width: 55%;
              float: left;
              height: 90px;
            "
          >
            <div
              v-for="that in item.itemVos"
              style="width: 100%; height: 90px"
              :key="that.orderItemId"
            >
              <div style="width: 100px; margin-left: 10px; float: left">
                <img
                  :src="that.goodsUrl"
                  v-show="that.goodsUrl"
                  alt=""
                  style="
                    width: 100%;
                    height: 70px;
                    margin-top: 10px;
                    object-fit: contain;
                  "
                />
                <img
                  src="@/assets/img/bitmap.png"
                  v-show="!that.goodsUrl"
                  alt=""
                  style="
                    width: 100%;
                    height: 70px;
                    margin-top: 10px;
                    object-fit: contain;
                  "
                />
              </div>
              <div
                style="
                  margin-left: 10px;
                  float: left;
                  height: 89px;
                  width: 350px;
                "
              >
                <div
                  style="
                    float: left;
                    margin-left: 20px;
                    font-weight: bold;
                    width: 100%;
                  "
                >
                  <div
                    style="
                      margin-top: 25px;
                      width: 95%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ that.oldBrand }} {{ that.oldGoodsCode }}
                    {{ that.oldGoodsName }}
                  </div>
                  <div
                    style="
                      width: 95%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ $t("stockInquiry.specification") }}：{{
                      that.oldSpecification
                    }}
                    {{ that.oldModel }}
                  </div>
                </div>
              </div>
              <div
                style="
                  margin-left: 10px;
                  float: left;
                  line-height: 89px;
                  color: #999999;
                "
              >
                <i class="el-icon-close"></i>{{ that.goodsNum }}
              </div>
            </div>
          </div>
          <div
            style="box-sizing: border-box; width: 15%; float: left"
            :class="{
              activeOne2: item.itemVos.length === 1,
              activeTwo2: item.itemVos.length === 2,
              activeThree2: item.itemVos.length === 3,
            }"
          >
            <span
              style="font-weight: bold; font-size: 16px; margin-left: 10px"
              >{{ $t("common.currency") }}</span
            ><span style="font-weight: bold; font-size: 16px; color: #d40000">{{
              item.money | formatePrice4
            }}</span>
          </div>
          <div
            :class="{
              activeOne2: item.itemVos.length === 1,
              activeTwo2: item.itemVos.length === 2,
              activeThree2: item.itemVos.length === 3,
            }"
            style="
              box-sizing: border-box;
              width: 15%;
              float: left;
              font-weight: bold;
              font-size: 14px;
              padding-left: 20px;
            "
          >
            <div v-if="item.orderStatus === '10'">
              {{ $t("stockNeed.tabs2") }}
            </div>
            <div v-if="['20', '30', '40', '50'].includes(item.orderStatus)">
              {{ $t("stockNeed.tabs5") }}
            </div>
            <div v-if="['60', '70'].includes(item.orderStatus)">
              {{ $t("stockNeed.tabs6") }}
            </div>
            <div v-if="item.orderStatus === '80'">
              {{ $t("stockNeed.tabs4") }}
            </div>
            <div v-if="item.orderStatus === '90'">
              {{ $t("applystatus.cancel") }}
            </div>
          </div>
          <div
            :class="{
              activeOne2: item.itemVos.length === 1,
              activeTwo2: item.itemVos.length === 2,
              activeThree2: item.itemVos.length === 3,
            }"
            style="
              box-sizing: border-box;
              width: 15%;
              float: left;
              color: #0064c0;
            "
          >
            <el-button
              type="text"
              size="small"
              style="color: #0064c0"
              @click="openDetailHandle(item.orderId)"
              >{{ $t("stockNeed.lookDetails") }}</el-button
            >
            <el-button
              type="text"
              size="small"
              style="color: #0064c0"
              @click="openDetailUpdate(item.orderId)"
              v-if="item.orderStatus === '10'"
              >{{ $t("update") }}</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="item.orderStatus === '10'"
              @click="cancel(item)"
              >取消订单</el-button
            >
            <!-- <el-button
              type="text"
              size="small"
              style="color:#0064C0"
              v-if="item.orderStatus === '60' || item.orderStatus === '70'"
              @click="deliveryHandle(item)"
              >发货单详情</el-button
            > -->
          </div>
        </div>
      </div>
      </div>
      <div class="empty" v-if="!dataList || !dataList.length">
        <img src="@/assets/img/good/noGood.png" />
        <div>暂无数据</div>
      </div>
      <!-- <el-table :data="dataList"
                border
                style="margin-top:10pxs"
                :default-expand-all="true"
                @selection-change="selectionChangeHandle">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.itemVos"
                      border
                      :span-method="objectSpanMethod"
                      style="width: 100%">
              <el-table-column prop="date"
                               label="备件领用详情"
                               width="500">
                <template slot-scope="scope">
                  <div>
                    <div style="width:100px;margin-left:10px;float:left">
                      <img :src="scope.row.goodsUrl"
                           alt=""
                           style="width:100%">
                    </div>
                    <div style="float:left;margin-left:20px;">
                      <div>{{scope.row.brandName}} {{scope.row.goodsModel}} {{scope.row.goodsName}}</div>
                      <div>规格型号：{{scope.row.oldSpecification}} {{scope.row.oldModel}}</div>
                      <div>数量：{{scope.row.goodsNum}}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money"
                               label="金额"
                               width="180">
              </el-table-column>
              <el-table-column prop="status"
                               label="状态">
                <template slot-scope="scope">
                  <div v-if="props.row.orderStatus === '10'">提交领用</div>
                  <div v-if="props.row.orderStatus === '30'">仓储受理</div>
                  <div v-if="props.row.orderStatus === '59' || scope.row.orderStatus === '41'">已完成</div>
                  <div v-if="props.row.orderStatus === '99'">已取消</div>
                  <div v-if="props.row.orderStatus === '49'">已评价</div>
                  <div v-if="props.row.orderStatus === '31'">物流配送</div>
                </template>
              </el-table-column>
              <el-table-column prop="address"
                               label="操作">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             @click="openDetailHandle(scope.row.orderId)"
                             v-if="props.row.orderStatus !== '10'">查看详情</el-button>
                  <el-button type="text"
                             size="small"
                             @click="openDetailUpdate(scope.row.orderId)"
                             v-if="props.row.orderStatus === '10'">查看详情</el-button>
                  <el-button type="text"
                             size="small"
                             v-if="props.row.orderStatus === '31' || scope.row.orderStatus === '59' || scope.row.orderStatus === '49'"
                             @click="deliveryHandle(scope.row)">发货单详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column type="index"
                         width="50"
                         label="序号"></el-table-column>
        <el-table-column prop="createTime"
                         header-align="center"
                         align="center"
                         label="申请时间"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderCode"
                         header-align="center"
                         align="center"
                         label="领用单号"
                         show-overflow-tooltip>
        </el-table-column>
      </el-table> -->
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <!-- 取消订单 -->
    <el-dialog
      title="取消订单"
      :visible.sync="cancelOrderVisible"
      width="667px"
    >
      <CancelOrder
        v-if="cancelOrderVisible"
        @submit="cancelOrder"
        @close="cancelOrderVisible = false"
      />
    </el-dialog>
  </div>
</template>
<script>
import exportFun from '@/utils/export.js'
import { formateDate } from '@/utils/formateDate'
import Copyable from '../components/copyable.vue'
import CancelOrder from './cancelOrder.vue'
import Breadcrumb from '@/components/breadcrumb/index'
export default {
  components: {
    Copyable,
    CancelOrder,
    Breadcrumb
  },
  data () {
    return {
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareOrder')
        }
      ],
      activeStatus: '1',
      selectList: [],
      showsearchall: false,
      dataForm: {
        receiveCode: '',
        status: '',
        customerName: '',
        custGoodsCode: '', // 用户物品编码
        model: '', // 物品型号
        goodsName: '', // 物品名称
        dateValue: ['', ''],
        dateValue2: [],
        dateValue3: '',
        searchInput: ''
      },
      number: 'all',
      statusList: [
        { code: '10', value: '提交领用' },
        { code: '30', value: '仓储受理' },
        { code: '31', value: '物流配送' },
        { code: '99', value: this.$t('applystatus.cancel') },
        { code: '49', value: this.$t('applystatus.evaluate') },
        { code: '59', value: this.$t('applystatus.complete') }
      ],
      dateOptions: [
        { code: '0', value: this.$t('product.optTime1') },
        { code: '1', value: this.$t('product.optTime2') },
        { code: '2', value: this.$t('product.optTime3') },
        { code: '3', value: this.$t('product.optTime4') }
      ],
      dataList: [],
      dataLoading: false,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 0, // 总页数
      pageSize: 10,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1, // 跳转页
      daishouliNumber: 0,
      daifahuoNumber: 0,
      daishouhuoNumber: 0,
      orderStatusArr: {},
      downloadLoading: false,
      row: {},
      cancelOrderVisible: false
    }
  },
  mounted () {
    this.getDataList()
    this.setStautsNumber()
  },
  methods: {
    cancel (item) {
      this.row = item
      this.cancelOrderVisible = true
    },
    // 取消订单
    cancelOrder (input) {
      const obj = {
        orderId: this.row.orderId,
        ...input
      }
      this.$http
        .post('/front/order/lclb/receive/cancelOrder', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.cancelOrderVisible = false
            this.getDataList()
            this.setStautsNumber()
          }
        })
        .catch(() => {})
    },
    changeTimeTag () {
      if (
        this.dataForm.timeTag !== null &&
        this.dataForm.timeTag !== '' &&
        this.dataForm.timeTag !== undefined
      ) {
        this.dataForm.dateValue = ['', '']
      }
    },
    changedateValue () {
      if (this.dataForm.dateValue[0] && this.dataForm.dateValue[1]) {
        this.dataForm.timeTag = ''
      }
    },
    hideAll () {
      this.showsearchall = false
    },
    showAll () {
      this.showsearchall = true
    },
    changeStatus (val) {
      this.dataForm.status = val
      this.number = val
      if (val === 'all') {
        this.dataForm.status = ''
      } else {
        this.dataForm.status = val
      }
      this.getDataList(1)
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        return {
          rowspan: 3,
          colspan: 1
        }
      }
    },
    clickItem (e, value) {
      e.preventDefault()
      value === this.dataForm.dateValue3
        ? (this.dataForm.dateValue3 = '')
        : (this.dataForm.dateValue3 = value)
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    routerHandle (routerName) {
      this.$router.push(routerName)
    },
    handleSaveReceive () {
      // this.$router.push({ name: 'spareGetAdd' })
      let params = {
        companyId:
          localStorage.getItem('defaultCompanyId') !== ''
            ? localStorage.getItem('defaultCompanyId')
            : null
      }
      this.$http
        .post(`/front/order/lclb/accountbill/checkPaid`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$router.push({ name: 'spareGetAdd' })
          }
        })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    getParams () {
      if (!this.dataForm.dateValue) {
        this.dataForm.dateValue = ['', '']
      }
      let params = {
        orderStatusArr: this.dataForm.status,
        orderCode: this.dataForm.receiveCode,
        startDate: this.dataForm.dateValue[0],
        endDate: this.dataForm.dateValue[1],
        timeTag: this.dataForm.timeTag,
        oldGoodsCode: this.dataForm.custGoodsCode,
        oldModel: this.dataForm.model,
        oldGoodsName: this.dataForm.goodsName,
        searchInput: this.dataForm.searchInput,
        companyId:
          localStorage.getItem('defaultCompanyId') !== ''
            ? localStorage.getItem('defaultCompanyId')
            : null
      }
      return params
    },
    // 下载
    download () {
      if (this.downloadLoading) {
        return
      }
      this.downloadLoading = true
      const fileName = `宁东工业超市领用单明细_${formateDate(
        'yyyy-MM-dd hh:mm:ss',
        new Date().getTime()
      )}.xls` // 下载的文件名
      exportFun({
        url: '/front/consumer/edge/export/my-receive-spare-part-list',
        name: fileName,
        params: {
          ...this.getParams()
        },
        haveMsg: false
      }).then((t) => {
        // 操作成功
        this.downloadLoading = false
        if (t) {
          this.$message.success(this.$t('message.downloadSuccess'))
        }
      })
    },
    getDataList (currentPage = this.currentPage) {
      let params = {
        page: currentPage,
        limit: this.pageSize,
        ...this.getParams()
      }
      this.dataLoading = true
      this.$http
        .post(`/front/order/lclb/receive/listByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.data
            this.dataList.forEach((item, index) => {
              if (item.itemVos) {
                if (item.itemVos.length > 3) {
                  item.itemVos = item.itemVos.splice(0, 3)
                }
              } else {
                item.itemVos = []
              }
            })
            this.totalPage = Number(res.data.count) || 0
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
          // this.setStautsNumber()
        })
        .catch(() => {
          this.dataList = []
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    setStautsNumber () {
      this.daishouliNumber = 0
      this.daifahuoNumber = 0
      this.daishouhuoNumber = 0
      let params = {
        orderStatus: this.dataForm.status,
        orderCode: this.dataForm.receiveCode,
        startDate: this.dataForm.dateValue[0],
        endDate: this.dataForm.dateValue[1],
        timeTag: this.dataForm.timeTag,
        oldGoodsCode: this.dataForm.custGoodsCode,
        oldModel: this.dataForm.model,
        oldGoodsName: this.dataForm.goodsName,
        companyId:
          localStorage.getItem('defaultCompanyId') !== ''
            ? localStorage.getItem('defaultCompanyId')
            : null
      }
      this.$http
        .post(`/front/order/lclb/receive/getStatusCountByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const orderStatusArr = {
              type1: 0,
              type2: 0,
              type3: 0,
              type4: 0,
              type5: 0
            }
            res.data.forEach((item) => {
              switch (item.status) {
                case 10:
                  orderStatusArr.type1 = item.cnt
                  break
                case 20:
                case 30:
                case 40:
                case 50:
                  orderStatusArr.type2 += item.cnt
                  break
                case 60:
                case 70:
                  orderStatusArr.type3 += item.cnt
                  break
                case 80:
                  orderStatusArr.type4 = item.cnt
                  break
                case 90:
                  orderStatusArr.type5 = item.cnt
                  break
                default:
                  break
              }
            })
            this.orderStatusArr = orderStatusArr
            // for (let i = 0; i < res.data.length; i++) {
            //   if (res.data[i].status === 10) {
            //     this.daishouliNumber = res.data[i].cnt
            //   }
            //   if (res.data[i].status === 30) {
            //     this.daifahuoNumber = res.data[i].cnt
            //   }
            //   if (res.data[i].status === 31) {
            //     this.daishouhuoNumber = res.data[i].cnt
            //   }
            // }
          }
        })
        .catch(() => {})
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 清空form
    reset () {
      this.dataForm = {
        receiveCode: '',
        status: '',
        customerName: '',
        dateValue: null,
        dateValue2: [],
        dateValue3: ''
      }
      this.getDataList(1)
    },
    // 跳转详情
    openDetailHandle (id) {
      const srcInfo = this.$router.resolve({
        name: 'spareGetDetail',
        query: { id: id }
      })
      window.open(srcInfo.href, '_blank')
    },
    deliveryHandle (row) {
      this.$router.push({
        name: 'shipmentDetail',
        query: {
          orderId: row.orderId,
          orderCode: row.orderCode,
          orderStatus: this.$getDictLabel('ORDER_STATUS', row.orderStatus),
          userName: row.applyUserName,
          companyName: row.companyName
        }
      })
    },
    openDetailUpdate (id) {
      const srcInfo = this.$router.resolve({
        name: 'spareGetDetailUpdate',
        query: { id: id }
      })
      window.open(srcInfo.href, '_blank')
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
.activeOne {
  height: 90px !important;
}
.activeTwo {
  height: 180px !important;
}
.activeThree {
  height: 270px !important;
}
.activeOne2 {
  height: 90px !important;
  line-height: 89px;
}
.activeTwo2 {
  height: 180px !important;
  line-height: 179px;
}
.activeThree2 {
  height: 270px !important;
  line-height: 269px;
}
.tabletitle {
  height: 50px;
  line-height: 50px;
  width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
}
.tabletitle div {
  float: left;
  background: #eeeeee;
  font-weight: bold;
  padding-left: 20px;
  box-sizing: border-box;
}
.lianchulianbei {
  background: white;
  padding: 20px;
  padding-top: 5px;
  /* border-top: 1px solid #ccc; */
}
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 250px;
  margin-right: 20px;
}
.search-but {
  width: 100px;
  text-align: left;
  float: right;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-word;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tabs {
  height: 48px;
  margin: 0 69px;
}
.tab-item {
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #ffffff;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active {
  color: #1d65a8;
  border-bottom: 2px solid #1d65a8;
}
.tab-item-content {
  padding-top: 10px;
}
.zhuangtai {
  width: auto;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  color: rgb(56, 50, 50);
  float: left;
  cursor: pointer;
  min-width: 90px;
  padding: 0 15px;
}
.zhuangtaiclick {
  border-bottom: 3px solid #1492ff;
  color: #1492ff;
}

.primary {
  border-color: #1492ff;
  background: #1492ff;
}

.primary:hover {
  opacity: 0.8;
}
.empty{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
